import React, { useState } from 'react';
import PropTypes from 'prop-types';
import VideoPlayer, {
  HLS_EXTENSIONS,
} from '@rsos/components/capstone/base/VideoPlayer/VideoPlayer';
import './CustomImageRenderer.scss';

const CustomImageRenderer = props => {
  const [viewingThumb, setViewingThumb] = useState(false);
  const { data, schema, path, onZoom } = props;

  const handleZoom = imageURL => {
    onZoom(imageURL);
  };

  const renderMedia = () => {
    if (HLS_EXTENSIONS.test(data.props.src)) {
      return (
        <VideoPlayer
          playerId={`video-${data.props.src}`}
          controls
          src={data.props.src}
        />
      );
    } else if (viewingThumb) {
      return (
        <img
          src={data.props.src}
          className="default-type-string-format-image-thumbnail"
          onClick={() => {
            handleZoom(data.props.src);
          }}
        />
      );
    } else {
      return <button onClick={() => setViewingThumb(true)}>View Image</button>;
    }
  };

  return (
    <div className="CustomImageRenderer">
      <div className={`default-type-string depth-${path.length}`}>
        <strong className="default-type-string-title">{schema.title}</strong>{' '}
        <span className="default-type-string-value">{renderMedia()}</span>
      </div>
    </div>
  );
};

CustomImageRenderer.propTypes = {
  data: PropTypes.shape().isRequired,
  schema: PropTypes.shape().isRequired,
  path: PropTypes.arrayOf(PropTypes.string).isRequired,
  onZoom: PropTypes.func.isRequired,
};

export default CustomImageRenderer;
